import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {SessionService} from './session.service';
import {UiService} from '../shared/state/ui.service';

interface EjbError {
  code: number;
  errType: 'BLException';
  message: string;
  object: any;
  stackTrace: string;
}

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  constructor(private sess: SessionService, private ui: UiService) {
    super();
  }

  handleError(error) {
    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error);
      return;
    }
    if (error instanceof Error) {
      this.ui.error(error.message);
      return;
    }
    super.handleError(error);
  }

  private handleHttpError(err: HttpErrorResponse) {
    switch (err.status) {
      case 401:
      case 403:
        this.handleUnauthorized(err);
        break;
      case 500:
        if (err.error && err.error.code) {
          this.handleEjbError(err.error);
          return;
        }
        this.handleUnexpectedISE(err);
        break;
      default:
        this.ui.error(err.message);
    }
  }

  private handleEjbError(err: EjbError) {
    if (err.code === 403) {
      this.handleUnauthorized(err);
      return;
    }
    this.ui.error(err.message.replace('hk.com.takad.www.tkweb.core.ApplicationException:', ''));
  }

  private handleUnexpectedISE(err: any) {
    this.ui.error(err.error ? err.error : err.message);
  }

  private handleUnauthorized(er: any) {
    this.ui.error(er.error.error || er);
    this.sess.signOut();
  }

}
